import { useEffect, useState, useCallback } from "react";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminSettings() {
  const [form, setForm] = useState({ calendly_url: "", contact_email: "", phone: "", instagram: "", linkedin: "", facebook: "" });
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    api.get("/admin/settings").then((r) => setForm((f) => ({ ...f, ...r.data }))).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { calendly_url, contact_email, phone, instagram, linkedin, facebook } = form;
      await api.put("/admin/settings", { calendly_url, contact_email, phone, instagram, linkedin, facebook });
      toast.success("Settings saved");
    } catch { toast.error("Save failed"); }
    finally { setLoading(false); }
  };

  const inputCls = "w-full bg-ivory border border-champagne/40 rounded-lg px-4 py-3 text-espresso focus:outline-none focus:ring-2 focus:ring-champagne";

  return (
    <div data-testid="admin-settings">
      <h1 className="font-serif text-4xl text-espresso">Settings</h1>
      <p className="text-espresso/60 mt-2">Connect your booking calendar and update contact details.</p>

      <form onSubmit={save} className="mt-8 max-w-2xl space-y-6">
        <div className="bg-taupe rounded-2xl p-6">
          <h2 className="font-serif text-xl text-espresso mb-1">Booking (Calendly)</h2>
          <p className="text-espresso/60 text-sm mb-4">Paste your Calendly scheduling link (e.g. https://calendly.com/yourname). This powers the live booking page — until it's set, visitors see a graceful placeholder instead of fictional availability.</p>
          <input value={form.calendly_url} onChange={(e) => set("calendly_url", e.target.value)} placeholder="https://calendly.com/your-handle" className={inputCls} data-testid="settings-calendly" />
        </div>

        <div className="bg-taupe rounded-2xl p-6 space-y-4">
          <h2 className="font-serif text-xl text-espresso">Contact & Social</h2>
          <div>
            <label className="block text-sm font-medium text-espresso mb-2">Contact email</label>
            <input value={form.contact_email} onChange={(e) => set("contact_email", e.target.value)} className={inputCls} data-testid="settings-email" />
          </div>
          <div>
            <label className="block text-sm font-medium text-espresso mb-2">Phone</label>
            <input value={form.phone} onChange={(e) => set("phone", e.target.value)} className={inputCls} />
          </div>
          <div className="grid md:grid-cols-3 gap-4">
            <input value={form.instagram} onChange={(e) => set("instagram", e.target.value)} placeholder="Instagram URL" className={inputCls} />
            <input value={form.linkedin} onChange={(e) => set("linkedin", e.target.value)} placeholder="LinkedIn URL" className={inputCls} />
            <input value={form.facebook} onChange={(e) => set("facebook", e.target.value)} placeholder="Facebook URL" className={inputCls} />
          </div>
        </div>

        <button type="submit" disabled={loading} data-testid="settings-save" className="inline-flex items-center gap-2 bg-espresso text-ivory rounded-full px-7 py-3 font-medium hover:bg-forest transition-colors disabled:opacity-60">
          {loading ? <Loader2 className="animate-spin" size={18} /> : <Check size={18} />} Save Settings
        </button>
      </form>
    </div>
  );
}
